import React from 'react';

const SquareConnectContent = ({ onClose, isAlreadyConnected = false }) => (
  <div className="p-4">
    {isAlreadyConnected && (
      <div className="mb-4 text-center">
        <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-200">
          <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
          </svg>
          Already Connected
        </span>
      </div>
    )}
    <p className="mb-4">Square connection flow will go here.</p>
    <button className="btn bg-indigo-500 hover:bg-indigo-600 text-white" onClick={onClose}>Close</button>
  </div>
);

export default SquareConnectContent; 